export default {
  "content": "<path d=\"M11 4c2.21 0 4 1.79 4 4 0 1.07-.42 2.07-1.16 2.83-.76.76-1.77 1.17-2.84 1.17H5c-2.21 0-4-1.79-4-4 0-1.07.42-2.07 1.16-2.83C2.92 4.41 3.93 4 5 4h6zm0-1H5c-1.38 0-2.63.56-3.54 1.46C.56 5.37 0 6.62 0 8c0 2.76 2.24 5 5 5h6c1.38 0 2.63-.56 3.54-1.46C15.44 10.63 16 9.38 16 8c0-2.76-2.24-5-5-5z\"/><path d=\"M11 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0-1C9.34 5 8 6.34 8 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};